module.exports = __webpack_public_path__ + "media/Video 37.5f9bc5b5.mp4";